const PDF_TEXT_FIELD_SELECTOR = [
  'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="button"]):not([type="submit"]):not([type="reset"])',
  'textarea',
].join(',')

/**
 * html2canvas clones form controls before rendering. Browser-managed input values are
 * properties, not child text, and can disappear from that clone. Replace text controls only in
 * the throwaway PDF DOM with ordinary elements so card and billing details remain visible.
 */
export function exposeAuthorizationPdfFormValues(sourceRoot, clonedRoot) {
  if (!sourceRoot || !clonedRoot) return

  const sourceFields = Array.from(sourceRoot.querySelectorAll(PDF_TEXT_FIELD_SELECTOR))
  const clonedFields = Array.from(clonedRoot.querySelectorAll(PDF_TEXT_FIELD_SELECTOR))

  sourceFields.forEach((sourceField, index) => {
    const clonedField = clonedFields[index]
    if (!clonedField) return

    const value = sourceField.value || ''
    const replacement = clonedField.ownerDocument.createElement(
      sourceField.tagName === 'TEXTAREA' ? 'div' : 'span',
    )

    Array.from(clonedField.attributes).forEach((attribute) => {
      replacement.setAttribute(attribute.name, attribute.value)
    })
    replacement.setAttribute('data-pdf-form-value', '')
    replacement.textContent = value

    const sourceStyle = window.getComputedStyle(sourceField)
    replacement.style.display = 'block'
    replacement.style.boxSizing = 'border-box'
    replacement.style.width = sourceStyle.width
    replacement.style.height = sourceStyle.height
    replacement.style.padding = sourceStyle.padding
    replacement.style.font = sourceStyle.font
    replacement.style.lineHeight = sourceStyle.lineHeight
    replacement.style.color = sourceStyle.color
    replacement.style.backgroundColor = sourceStyle.backgroundColor
    replacement.style.border = sourceStyle.border
    replacement.style.borderRadius = sourceStyle.borderRadius
    replacement.style.overflow = 'hidden'
    replacement.style.whiteSpace = 'nowrap'

    clonedField.replaceWith(replacement)
  })
}
